import React, { Dispatch, useEffect } from 'react';
import { AutoComplete, Form, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/fornecedor/actions';
import { Props } from '../props';
import mask from '../../../../../../utils/mask';

const SelectFornecedor: React.FC<Props> = ({ setProps }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const fonecedor = useSelector((state: ApplicationState) => state.Fornecedor.data);
  const { Option } = AutoComplete;
  useEffect(() => {
    dispatch(loadRequest());
  }, [dispatch]);

  return (
    <Form.Item rules={[{ required: true, message: 'Selecione o fornecedor' }]} name="fornecedor">
      <Select
        placeholder="Selecione o fornecedor"
        style={{ width: '100%' }}
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        showSearch
        onSelect={(value) => {
          setProps(value);
        }}
      >
        {fonecedor.map((item) =>


          (
          <Option key={item.codParc} value={item.codParc}>
            {mask('camelCase', item.nome)} <br />
            {mask('cpfCnpj', item.cnpjCpf)} <br />
            {item.codParc}

          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default SelectFornecedor;
